import { render, staticRenderFns } from "./DetailLowMovingStock.vue?vue&type=template&id=1e9fed92&scoped=true&"
import script from "./DetailLowMovingStock.vue?vue&type=script&lang=js&"
export * from "./DetailLowMovingStock.vue?vue&type=script&lang=js&"
import style0 from "./DetailLowMovingStock.vue?vue&type=style&index=0&id=1e9fed92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9fed92",
  null
  
)

export default component.exports